module.exports = __webpack_public_path__ + "img/emoji_42.4df2df60.png";